import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export enum ChipFilterPriority {
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum ChipFilterActionType {
  Tag = 'tag',
  Dropdown = 'dropdown',
  Removable = 'removable',
}

export enum ChipFilterSize {
  XS = 'xs',
  SM = 'sm',
  RG = 'rg',
}

export enum ChipFilterState {
  Default = 'default',
  Highlight = 'highlight',
  Disabled = 'disabled',
}

export interface ChipFilterOption {
  Key?: string;
  Label?: string;
  Icon?: Icon;
  SpecialIcon?: boolean;
}
